import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const pmiValue = (state, props) => (
  whatIfInnerSelector(state, props).Pmi
);

export default pmiValue;
